import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "BaseDataService",
  controller: "UniformConfig",
};

const methods = [
  "GetDataBySearch",
  "GetConfigItemsList",
  "GetConfigItemsListExt"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
      Fun.prototype[path] = function(data) {
        return this.post(path, data);
      };
  });
};

const UniformConfigApi = ZJApi.defineNewApi("UniformConfigApi", factory);

export default UniformConfigApi;
